/* Pequeñas herramientas del dibujo (idénticas a la maqueta). */

export const f1 = (v: number) => Math.round(v * 10) / 10;

/** Posiciones relativas a un punto de apoyo: X a la derecha, Y hacia arriba, L longitudes. */
export const geo = (x: number, b: number, s: number) => ({
  X: (d: number) => f1(x + d * s),
  Y: (d: number) => f1(b - d * s),
  L: (d: number) => f1(d * s),
});

/** Azar con semilla: cada día dibuja siempre el mismo paisaje. */
export function azar(semilla: number): () => number {
  let a = semilla >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export const hex = (h: string) => [1, 3, 5].map(i => parseInt(h.slice(i, i + 2), 16));
export const aHex = (c: number[]) => '#' + c.map(v => Math.round(Math.max(0, Math.min(255, v))).toString(16).padStart(2, '0')).join('');
export const mezcla = (a: string, b: string, t: number) => { const A = hex(a), B = hex(b); return aHex(A.map((v, i) => v + (B[i] - v) * t)); };
export const luz = (h: string) => {
  const [r, g, b] = hex(h).map(v => { v /= 255; return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4; });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};
